import { render, staticRenderFns } from "./trainingModulePageNew6.vue?vue&type=template&id=2a788adf&scoped=true&"
import script from "./trainingModulePageNew6.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew6.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew6.vue?vue&type=style&index=0&id=2a788adf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a788adf",
  null
  
)

export default component.exports